import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective } from 'ngx-mask';
import Swal from 'sweetalert2';
import { RestClientService } from '../../../../core/service/rest-client.service';
import { AuthService } from '../../../../core/service/auth.service';
import { UtilitiesService } from '../../../../core/service/utilities.service';
import { BenefInfoComponent } from '@shared/components/benef-info/benef-info.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { FileUploadComponent } from '@shared/components/file-upload/file-upload.component';
import { IntegerFormatPipe } from '../../../../shared/pipe/integer-format.pipe';
import { SearchFormComponent } from '@shared/components/search-form/search-form.component';

@Component({
  selector: 'app-form-consultation',
  standalone: true,
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    BenefInfoComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    FileUploadComponent,
    CommonModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatButtonModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSlideToggleModule,
    IntegerFormatPipe,
    SearchFormComponent,
  ],
  templateUrl: './form-consultation.component.html',
  styleUrl: './form-consultation.component.css',
})
export class FormConsultationComponent {
  selectedTab = 'tab1';
  @Output() onSendBenefItem = new EventEmitter<any>();
  @Output() onSendConsultationStatut = new EventEmitter<any>();
  @Output() onCloseConsultationModal = new EventEmitter<any>();
  @Output() onGoToTab = new EventEmitter<any>();
  @Input() matricule: any;
  itemBeneficiare: any = {};

  isLoading: boolean | undefined;
  isLoadingTarif = false;
  isSaving = false;
  input_value: any;
  input_option = 'MAT';
  searchPlaceHolder = 'Entrez numéro matricule';
  user: any = {};
  isConsultationSuccess = false;
  itemConsultation: any = {};
  @Input() refreshTriggerConsultation!: boolean;
  medecins = [
    { id: 1, name: 'Dr. John', specialite: 'Cardiologue' },
    { id: 1, name: 'Dr. Méa', specialite: 'Docteur' },
    { id: 1, name: 'Dr. Yves', specialite: 'Dermato' },
  ];
  actes = [
    { id: 1, name: 'Consultation généraliste' },
    { id: 2, name: 'Consultation spécialiste' },
  ];
  itemsPratitien: any;
  itemsActe: any;
  itemTarifActe: any;
  itemsRaisonConsultation: any = [];
  fileName1: any;
  currentFile: any;
  itemsGarantie: any = [];
  beneficiaireAutOselect: any;
  latitude: number | null = null;
  longitude: number | null = null;
  constructor(
    private restClient: RestClientService,
    private router: Router,
    private authService: AuthService,
    private utilities: UtilitiesService,
  ) {
    // this.authService.setActiveBeneficiaire({})
    this.user = this.authService.getCurrentUser();
    console.log('connected user: ', this.user);
    this.getItemsGarantie();
    this.beneficiaireAutOselect = '';

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          console.log('Captured Lat:', this.latitude, 'Lng:', this.longitude);
          let pos = { latitude: this.latitude, longitude: this.longitude };
          this.authService.setUserPosition(pos);
        },
        (error) => {
          console.error('Error capturing location:', error);
        },
      );
    } else {
      console.error('Geolocation not supported by this browser.');
    }
    this.authService.setActiveBeneficiaire({});
  }

  onSelectTab(tab: string) {
    this.selectedTab = tab;
  }

  onChangeInputMode() {
    this.input_value = '';
    this.searchPlaceHolder =
      this.input_option == 'MAT'
        ? 'Entrez numéro matricule'
        : 'Entrez numéro cnam';
  }

  onSetUserInfo(event: any) {
    if (event.id) {
      this.itemBeneficiare = event;
      this.authService.setActiveBeneficiaire(event);
      this.itemConsultation = {};
      this.beneficiaireAutOselect = this.itemBeneficiare;
      this.onSendBenefItem.emit(event);
    } else {
      this.authService.setActiveBeneficiaire({});
      this.beneficiaireAutOselect = {};
      this.onSendBenefItem.emit({});
    }
  }

  getItemsMedecin() {
    let request = {
      index: 0,
      size: 1000,
      data: {
        acte_id: this.itemConsultation.acte_id,
      },
    };

    this.restClient.post('praticien/searchByPrestataire', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsPratitien = res.items;
          this.itemsPratitien.map(
            (ip: any) =>
              (ip.full_name =
                ip.nom + ' ' + ip.prenom + '(' + ip.specialite_libelle + ')'),
          );
          console.log('this.itemsPratitien: ', this.itemsPratitien);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsPratitien = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsPratitien = [];
      },
    );
  }
  savePrestation() {
    this.isConsultationSuccess = false;

    if (this.currentFile && Object.keys(this.currentFile).length) {
      this.itemConsultation.file_data = this.currentFile;
    } else {
      delete this.itemConsultation.file_data;
    }
    this.itemConsultation.code = this.generateUniqueString();
    this.itemConsultation.prix_unitaire = this.itemConsultation.montant;
    this.itemConsultation.prix_unitaire_accord = this.itemConsultation.montant;
    this.itemConsultation.taux_couverture =
      this.itemBeneficiare.taux_applicable;
    this.itemConsultation.taux_applicable =
      this.itemBeneficiare.taux_applicable;
    this.itemConsultation.quantite = 1;
    this.itemConsultation.quantite_accord = 1;
    this.itemConsultation.montant_remboursable = this.itemConsultation.montant;
    this.itemConsultation.montant_accorde =
      this.itemConsultation.part_assurance;
    this.itemConsultation.libelle = this.itemsActe.find(
      (ia: any) => ia.id == this.itemConsultation.acte_id,
    ).libelle;
    this.itemConsultation.beneficiaire_id = this.itemBeneficiare.id;
    this.itemConsultation.matricule = this.itemBeneficiare.matricule;
    this.itemConsultation.matricule_assure =
      this.itemBeneficiare.matricule_assure;
    this.itemConsultation.prestataire_id = this.user.prestataire_id;
    this.itemConsultation.is_factured = false;
    this.itemConsultation.is_hospit = false;
    this.itemConsultation.latitude = this.latitude;
    this.itemConsultation.longitude = this.longitude;

    const dataSinistre = {
      filiale_id: this.itemConsultation.filiale_id || this.user.filiale_id,
      beneficiaire_id: this.itemConsultation.beneficiaire_id,
      prestataire_id: this.itemConsultation.prestataire_id,
      matricule: this.itemConsultation.matricule,
      police_id: this.itemBeneficiare.police_id,
      college_id: this.itemBeneficiare.college_id,
      souscripteur_id: this.itemBeneficiare.souscripteur_id,
      garant_id: this.itemBeneficiare.garant_id,
      garantie_id: this.itemConsultation.garantie_id,
      exercice_id: this.itemBeneficiare.exercice_id,
      taux_applicable: this.itemConsultation.taux_applicable,
      taux_couverture: this.itemConsultation.taux_couverture,
      montant: this.itemConsultation.montant,
      part_patient: this.itemConsultation.part_patient,
      part_assurance: this.itemConsultation.part_assurance,
      depassement: this.itemConsultation.depassement ?? 0,
      statut: 'ATTENTE_PREVALIDATION_PRESTATAIRE',
    };
    const itemActe = { ...this.itemConsultation };
    delete itemActe.depassement;

    let request = {
      dataSinistre,
      datas: [itemActe],
    };

    this.isSaving = true;
    this.restClient.post('prestationActe/create', request).subscribe(
      (res: any) => {
        this.isSaving = false;
        if (res && !res['hasError']) {
          this.isConsultationSuccess = true;
          this.utilities.showSweetNotification(
            res['status']['message'],
            'succes',
          );
          const savedConsultation =
            res['items']?.[0] ?? res['item'] ?? this.itemConsultation;
          this.itemConsultation = {};
          this.onSendConsultationStatut.emit(true);
          this.onGoToTab.emit({
            tab: 'prescriptions',
            consultation: savedConsultation,
            beneficiaire: this.itemBeneficiare,
          });
        } else {
          this.isConsultationSuccess = false;
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.onSendConsultationStatut.emit(false);
        }
      },
      (error) => {
        this.isSaving = false;
        this.isConsultationSuccess = false;
        this.onSendConsultationStatut.emit(this.isConsultationSuccess);
        this.utilities.showSweetNotification(error, 'error');
      },
    );
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];

      console.info('fileName', fileName);
      console.info('extension', extension);
      this.fileName1 = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        // this.imageDisplay = data;
        const fileBase64 = data.split(',')[1];
        this.currentFile = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: 'custom type',
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  onGetDossiers() {}

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }
  getItemsActe() {
    if (!this.itemsGarantie || !this.itemsGarantie.length) return;
    let garantie_id = this.itemsGarantie.find(
      (gar: any) => gar.codification == 'CONS',
    ).id;
    let request = {
      index: 0,
      size: 1000,
      // search_key: 'CONSULT',
      data: {
        garantie_id: garantie_id,
      },
    };

    this.restClient.post('acte/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsActe = res.items;
          this.itemsActe = this.itemsActe.filter((it: any) => it.is_eligible);
          console.log('this.itemsActe: ', this.itemsActe);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsActe = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsActe = [];
      },
    );
  }
  // getItemsActe() {
  //   let request = {
  //     index: 0,
  //     size: 1000,
  //     search_key: 'CONSULT',
  //     data: {},
  //   };

  //   this.restClient.post('acte/searchByLibelle', request).subscribe(
  //     (res: any) => {
  //       this.isLoading = false;
  //       if (res && !res['hasError'] && res['items']) {
  //         this.itemsActe = res.items;
  //         console.log('this.itemsActe: ', this.itemsActe);
  //       } else {
  //         this.utilities.showSweetNotification(
  //           res['status']['message'],
  //           'error'
  //         );
  //         this.itemsActe = [];
  //       }
  //     },
  //     (error) => {
  //       this.utilities.showSweetNotification(error, 'error');
  //       this.itemsActe = [];
  //     }
  //   );
  // }

  confirmSaveItem() {
    // item.specialiteId = this.selectedSpecialite.id
    if (!this.itemConsultation || !this.itemConsultation.praticien_id) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner medecin',
        'error',
      );
      return;
    }
    if (!this.itemConsultation || !this.itemConsultation.acte_id) {
      this.utilities.showSweetNotification('Veuillez renseigner acte', 'error');
      return;
    }
    if (!this.itemConsultation.is_controle) {
      if (!this.itemConsultation || !this.itemConsultation.montant) {
        this.utilities.showSweetNotification(
          "Le montant de l'acte ne peut etre nul",
          'error',
        );
        return;
      }
    }

    if (
      !this.itemConsultation ||
      !this.itemConsultation.raison_consultation_id
    ) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner raison consultation',
        'error',
      );

      return;
    }

    Swal.fire({
      title: 'Consultation',
      text: 'Souhaitez-vous poursuivre cette action?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.savePrestation();
      }
    });
  }

  getTarifActe() {
    // this.itemConsultation={raison_consultation_id: this.itemConsultation.raison_consultation_id,praticien_id:this.itemConsultation.praticien_id}
    let request = {
      index: 0,
      size: 1000,
      data: {
        acte_id: this.itemConsultation.acte_id,
        matricule: this.itemBeneficiare.matricule,
        prestataire_codification: this.user.prestataire_codification,
      },
    };

    this.isLoadingTarif = true;
    // this.restClient.post('tarifActe/getActiveValues', request).subscribe(
    this.restClient.post('bareme/deepSeek', request).subscribe(
      (res: any) => {
        this.isLoadingTarif = false;
        if (res && !res['hasError'] && res['item']) {
          this.itemTarifActe = res.item;
          delete this.itemTarifActe.consommation;
          delete this.itemTarifActe.plafond;
          this.itemConsultation = {
            raison_consultation_id:
              this.itemConsultation.raison_consultation_id,
            praticien_id: this.itemConsultation.praticien_id,
            acte_id: this.itemConsultation.acte_id,
          };
          this.itemConsultation = {
            ...this.itemTarifActe,
            ...this.itemConsultation,
          };
          delete this.itemConsultation.id;
          console.log('this.itemTarifActe: ', this.itemTarifActe);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.isLoadingTarif = false;
          this.itemTarifActe = {};
          this.itemConsultation.acte_id = '';
          this.itemConsultation = {
            raison_consultation_id:
              this.itemConsultation.raison_consultation_id,
            praticien_id: this.itemConsultation.praticien_id,
          };
        }
      },
      (error) => {
        this.isLoadingTarif = false;
        this.utilities.showSweetNotification(error, 'error');
        this.itemConsultation = {
          raison_consultation_id: this.itemConsultation.raison_consultation_id,
          praticien_id: this.itemConsultation.praticien_id,
        };
        this.itemTarifActe = {};
      },
    );
  }
  getItemRaisonConsultation() {
    let request = {
      index: 0,
      size: 1000,
      order_by: '-libelle',
      data: {},
    };

    this.restClient.post('raisonConsultation/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsRaisonConsultation = res.items;
          console.log(
            'this.itemsRaisonConsultation: ',
            this.itemsRaisonConsultation,
          );
          this.itemConsultation.raison_consultation_id =
            this.itemsRaisonConsultation[0].id;
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsRaisonConsultation = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsRaisonConsultation = [];
      },
    );
  }

  getItemsGarantie() {
    let request = {
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient.post('garantie/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsGarantie = res.items;
          console.log('this.itemsGarantie: ', this.itemsGarantie);
          this.getItemsActe();

          this.itemConsultation.raison_consultation_id =
            this.itemsGarantie[0].id;
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsGarantie = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsGarantie = [];
      },
    );
  }

  onSelectMedecin() {
    // this.getItemsActe();
  }
  onSelectActe() {
    this.getTarifActe();
    this.getItemsMedecin();
    this.getItemRaisonConsultation();
  }

  goNext() {
    console.log('going next');
    this.onGoToTab.emit('ordonnance');
  }
}
